import { Button } from "@/components/design-system/button";
import { classApi } from "../api/classApi";
import ClassForm from "../components/ClassForm";
import type { ClassFormSchemaValues } from "../schemas/classForm.schema";
import { ADMIN_CLASS_USE_MOCK } from "../config/admin.config";
import { useLinkableGrades } from "../hooks/useLinkableGrades";
import {
  showApiErrorToast,
  showApiSuccessToast,
} from "../utils/apiToastMessage";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";

export default function AddClassPage() {
  const navigate = useNavigate();
  const { grades, loading: gradesLoading } = useLinkableGrades(ADMIN_CLASS_USE_MOCK);

  const handleSubmit = async (values: ClassFormSchemaValues) => {
    try {
      const result = await classApi.createClass(values);
      showApiSuccessToast(result.message, "Class added successfully");
      navigate("/class-management");
    } catch (e) {
      console.error(e);
      showApiErrorToast(e, "Could not create class. Please try again.");
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="h-[68px] px-[32px] items-center flex gap-3">
        <Button
          type="button"
          variant="light"
          size="md"
          className="w-[40px] h-[40px] p-0 bg-white border border-[#EDEDED] rounded-[8px]"
          onClick={() => navigate(-1)}
          leftIcon={<ChevronLeft className="w-5 h-5" />}
        >
          <span className="sr-only">Back</span>
        </Button>
        <div className="text-[#1F1F1F] text-[16px] font-semibold">Add Class</div>
      </div>
      <div className="flex-1 px-[32px] pb-[24px]">
        <ClassForm
          mode="create"
          grades={grades}
          gradesLoading={gradesLoading}
          onSubmit={handleSubmit}
          onClose={() => navigate(-1)}
          submitLabel="Add"
        />
      </div>
    </div>
  );
}
